import React from "react";
import Container from "./container";
import { cn } from "../lib/helpers";
import PortableText from "./portableText";

import * as styles from "../styles/components/section-header.module.css";

const SectionHeader = (props) => {
  const { title, subtitle, description, position, noBottomMargin = false} = props;
  return (
    <div
      className={cn(
        styles.root,
        props.greenBackground && styles.greenBackground,
        noBottomMargin && styles.noBottomMargin
      )}
    >
      <Container>
        {position === "captionFirst" ? (
          <>
            {subtitle && (
              <div className={cn("h3", styles.subtitle)}>{subtitle}</div>
            )}
            {title && <h2 className={styles.title}>{title}</h2>}
            {description && (
              <div className={cn("entry-content", styles.description)}>
                <PortableText blocks={description} />
              </div>
            )}
          </>
        ) : (
          <>
            {title && <h2 className={styles.title}>{title}</h2>}
            {subtitle && (
              <div className={cn("h3", styles.subtitle)}>{subtitle}</div>
            )}
            {description && (
              <div className={cn("entry-content", styles.description)}>
                <PortableText blocks={description} />
              </div>
            )}
          </>
        )}
      </Container>
    </div>
  );
};

export default SectionHeader;
